/***
 *
 *   404
 *   Generic 404 error page
 *
 **********/

import { Row, Button } from "components/lib";

export function NotFound({ t }) {
  return (
    <div className="text-white">
      <Row>
        <section>
          <h1 className="text-3xl font-bold mb-4">{t("error.404.title")}</h1>
          <p className="text-gray-300 mb-6">{t("error.404.description")}</p>
        </section>
      </Row>

      <Button
        text={t("error.404.button")}
        url="/dashboard"
        size="full"
        color="green"
      />
    </div>
  );
}
